<template>
  <div id="app">
    <el-container>
      <el-header style="border-bottom: 1px solid #ccc;">
        <myNav></myNav>
      </el-header>
      <el-container class="mainContainer">
        <el-aside width="200px">
          <myMenu :active="activeMenu" />
        </el-aside>
        <el-main style="height: calc(100vh - 60px);
    overflow-y: auto;">
          <router-view />
        </el-main>
      </el-container>
    </el-container>

    <!---登录弹窗--->

    <el-dialog :fullscreen=true
               top="calc(50vh - 277px)"
               :close-on-click-modal=false
               :close-on-press-escape=false
               :show-close=false
               width="960px"
               class="loginDialog"
               :visible.sync="curLoginDialog">

      <div class="loginDialogContainer"
           v-if="type==='login'">
        <el-row>
          <el-col :span="12">
            <br> <br> <br>
            <img src="./assets/imgs/login.jpg"
                 width="90%" />
          </el-col>
          <el-col :span="9"
                  :offset="0">
            <div style="width:100%;height:30px;"></div>

            <!---账号密码登录--->
            <template>
              <el-row style="text-align:left">
                <h3>&nbsp;&nbsp;你好</h3>
                <h4>&nbsp;&nbsp;欢迎登陆云天弈智能财经研究分析报告平台</h4>
                <div style="width:100%;height:0px;"></div>
                <el-form :model="accountForm"
                         :rules="accountRules"
                         action="javascript:void(0)"
                         ref="accoutRuleForm"
                         label-width="10px">
                  <el-form-item prop="mobile">
                    <el-input v-model="accountForm.mobile"
                              placeholder="请输入账号"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item prop="password">
                    <el-input placeholder="请输入密码"
                              v-model="accountForm.password"
                              show-password></el-input>
                  </el-form-item>

                  <el-form-item prop="imgCaptcha"
                                class="imgCaptchaContainer">
                    <el-input v-model="accountForm.imgCaptcha"
                              placeholder="图片验证码"
                              clearable>
                      <template slot="append">
                        <el-link type="primary"
                                 :underline=false
                                 @click="toGetImgCaptcha"> <img :src="imgCaptcha.img"
                               width="90px" />
                        </el-link>

                      </template>
                    </el-input>
                  </el-form-item>
                  <!-- <el-form-item prop="agreeChecked">
                      <div class="agreeContainer">
                        <el-checkbox v-model="accountForm.agreeChecked"></el-checkbox>
                        登录代表您已经同意 <el-link type="primary"
                                 @click="openAgreeDialog"
                                 :underline="false">《用户服务协议》</el-link>和 <el-link type="primary"
                                 :underline="false"
                                 @click="openDisclaimerDialog">《免责声明》</el-link>
                      </div>
                    </el-form-item> -->
                  <el-form-item style="text-align:left">
                    <el-button class="loginBtn"
                               type="primary"
                               native-type="submit"
                               @click="loginByMobile">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
                    <!-- <el-button @click="changeType('reg')">注册</el-button> -->
                  </el-form-item>
                  <!-- <el-form-item>
                    <el-link type="primary"
                             :underline="false"
                             :href="wechatUrl">微信登录>></el-link>
                  </el-form-item> -->
                </el-form>
                <div style="width:100%;height:10px;"></div>

              </el-row>
            </template>

          </el-col>
        </el-row>
      </div>
      <div class="loginDialogContainer"
           v-if="type==='reg'">
        <el-row>
          <el-col :span="8"
                  :offset="8">
            <div style="width:100%;height:60px;"></div>

            <!---注冊--->
            <template>
              <el-row>
                <h2>注册使用</h2>
                <div style="width:100%;height:30px;"></div>
                <el-form :model="regForm"
                         label-position="right"
                         :hide-required-asterisk=true
                         :rules="regRules"
                         action="javascript:void(0)"
                         ref="regForm"
                         label-width="100px"
                         class="demo-regForm">
                  <el-form-item prop="mobile"
                                label="手机号">
                    <el-input v-model="regForm.mobile"
                              :required=true
                              :hide-required-asterisk=true
                              placeholder="输入手机号"
                              @blur="checkMobile"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item prop="password"
                                label="密码">
                    <el-input placeholder="请输入密码"
                              v-model="regForm.password"
                              show-password></el-input>
                  </el-form-item>

                  <el-form-item prop="rePassword"
                                label="重复密码">
                    <el-input placeholder="请输入密码"
                              v-model="regForm.rePassword"
                              show-password></el-input>
                  </el-form-item>

                  <el-form-item prop="companyName">
                    <el-input v-model="regForm.companyName"
                              placeholder="公司名称"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item prop="job">
                    <el-input v-model="regForm.job"
                              placeholder="主要职务"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item prop="name">
                    <el-input v-model="regForm.name"
                              placeholder="您的姓名"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item prop="imageCaptcha">
                    <el-input v-model="regForm.imageCaptcha"
                              placeholder="图片验证码"
                              clearable>
                      <template slot="append">
                        <el-link type="primary"
                                 :underline=false
                                 @click="toGetImgCaptcha">
                          <img :src="imgCaptcha.img"
                               width="90px" />
                        </el-link>
                      </template>
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="smsCaptchaCode">
                    <el-input v-model="regForm.smsCaptcha"
                              placeholder="短信验证码"
                              clearable>
                      <template slot="append">
                        <el-link type="primary"
                                 @click="toSendSms">发送短信验证码</el-link>
                      </template>
                    </el-input>
                  </el-form-item>

                  <!-- <el-form-item prop="agreeChecked">
                      <div class="agreeContainer">
                        <el-checkbox v-model="accountForm.agreeChecked"></el-checkbox>
                        登录代表您已经同意 <el-link type="primary"
                                 @click="openAgreeDialog"
                                 :underline="false">《用户服务协议》</el-link>和 <el-link type="primary"
                                 :underline="false"
                                 @click="openDisclaimerDialog">《免责声明》</el-link>
                      </div>
                    </el-form-item> -->
                  <el-form-item style="text-align:left">
                    <el-button class="loginBtn"
                               type="primary"
                               native-type="submit"
                               @click="toReg">注&nbsp;&nbsp;&nbsp;&nbsp;册</el-button>
                    <el-button @click="changeType('login')">登录</el-button>
                  </el-form-item>
                  <el-form-item>
                    &nbsp;
                  </el-form-item>
                </el-form>
                <div style="
                                 width:100%;height:10px;">
                </div>

              </el-row>
            </template>

          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <!--支付弹出框-->
    <!-- <el-dialog class="payContainer"
               :visible.sync="payDialogVisible"
               width="780px"
               center>
      <pay v-if="payDialogVisible"
           :fileType="payData.fileType"
           :reportId="payData.id"
           :reportType="payData.reportType" />
    </el-dialog> -->

  </div>
</template>

<script>

import axios from 'axios'
import myMenu from './components/menu'
import myNav from './components/nav'
import pay from './components/pay'
export default {
  name: 'App',

  data () {
    return {
      activeMenu: '/',
      curLoginDialog: false,
      type: 'login',
      imgCaptcha: {},
      payDialogVisible: false,
      payData: {},
      fileType: '',
      reportType: '',
      accountForm: {
        mobile: '',
        password: '',
        imgCaptcha: '',
        agreeChecked: true
      },
      accountRules: {
        mobile: [
          { required: true, message: '登录账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' }
        ],
        imgCaptcha: [
          { required: true, message: '图片验证码不能为空', trigger: 'blur' }
        ]
      },
      regForm: {
        mobile: '',
        password: '',
        rePassword: '',
        agreeChecked: true,
        companyName: '',
        job: '',
        name: '',
        imageCaptcha: '',
        smsCaptcha: ''
      },
      regRules: {
        mobile: [
          { required: true, message: '登录账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' }
        ]
      },
      changeType (t) {
        this.type = t
      },
      wechatUrl: ''

    }
  },
  components: {
    myMenu, myNav, pay
  },
  mounted: function () {
    let token = this.$route.query.token
    let path = this.$route.query.path
    let code = this.$route.query.code
    let tenant = this.$route.query.tenant
    this.activeMenu = path
    let _this = this
    console.log('code:' + code)
    console.log('token:' + token)
    console.log('tenant:' + tenant)
    if (token && code) { // csmar 等代理商登录
      axios.get('/api/web/auth/logout').then(resp => {
        setTimeout(() => {
          axios.post('/api/web/proxy/login', this.$route.query).then(resp => {
            _this.$router.push({ 'path': '/' })
            _this.$store.commit('toFreshUserPrice')
            _this.$store.commit('refreshUserInfo')
            _this.loadWechatUrl(path)
          })
        }, 500)
      })
    } else if (tenant && code) {
      axios.get('/api/web/auth/logout').then(resp => {
        setTimeout(() => {
          axios.post('/api/web/proxy/huawei/login', this.$route.query).then(resp => {
            _this.$router.push({ 'path': '/' })
          })
        }, 500)
      })
    } else {
      this.loadWechatUrl(path)
    }
  },
  methods: {
    loadWechatUrl (path) {
      let _this = this
      axios.get('/api/web/wechat/url?state=' + path).then(resp => {
        _this.wechatUrl = resp.data
      })
    },
    toReg () {
      axios.post('/api/web/auth/regUser', this.regForm).then(resp => {
        localStorage.setItem('userInfo', JSON.stringify(resp.data))
        if (window.parent) {
          window.open(window.parent.location.href, '_top')
        }
        window.location.reload()
      })
    },
    loginByMobile () {
      let _this = this
      this.$refs['accoutRuleForm'].validate((valid) => {
        if (valid) {
          _this.accountForm.imgCaptchaKey = _this.imgCaptcha.key
          axios.post('/api/web/auth/login', _this.accountForm).then(resp => {
            localStorage.setItem('userInfo', JSON.stringify(resp.data))
            if (window.parent) {
              window.open(window.parent.location.href, '_top')
            }
            window.location.reload()
          })
        } else {
          return false
        }
      })
    },
    checkMobile () {
      if (this.regForm.mobile) {
        axios.post('/api/web/auth/checkMobile', { 'mobile': this.regForm.mobile })
      }
    },
    toSendSms () {
      axios.post('/api/web/auth/sendSmsCaptcha', { 'mobile': this.regForm.mobile, 'key': this.imgCaptcha.key, 'imgCaptcha': this.regForm.imageCaptcha })
    },
    toGetImgCaptcha () {
      let _this = this
      axios.get('/api/web/auth/captchaImg?' + Math.random()).then(resp => {
        _this.imgCaptcha = resp.data
      })
    }
  },
  computed: {
    payResult: function () {
      return this.$store.state.payResult
    },
    loginDialog () {
      return this.$store.state.loginDialogVisible
    },
    payDialog () {
      return this.$store.state.payDialogVisible
    }
  },
  watch: {
    payResult: function () {
      this.payDialogVisible = false
    },
    loginDialog: function () {
      if (this.loginDialog) {
        this.curLoginDialog = true
        this.toGetImgCaptcha()
      }
    },
    payDialog: function () {
      this.payData = this.$store.state.payData
      this.payDialogVisible = true
      this.$message.error('没有可使用次数了')
    }
  }

}
</script>
<style lang="less" >
@import "./assets/css/index.less";
.imgCaptchaContainer .el-input-group__append {
  background-color: white;
}
</style>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  min-height: 100vh;
}
html,
body {
  width: 100%;
  min-height: 100%;
  margin: 0px;
  padding: 0px;
  min-width: 1300px;
}

.el-header .el-dropdown {
  color: white;
}

.el-aside .el-menu-item:hover {
  color: #666666;
  background-color: #e8eaed;
}
.el-main {
  background-color: #f5f7fa;
}
.mainContainer {
  min-height: calc(100vh - 60px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue